import AcceptQuoteButton from './AcceptQuote';
import DeclineQuoteButton from './DeclineQuote';
import RequestChangesButton from './RequestChanges';
import useJobActionButtons from './useJobActionButtons';

const JobActionButtons: React.FunctionComponent = function () {
  const { showApplyButton, showRequestChangesButton } = useJobActionButtons();
  return (
    <div className="grid grid-cols-2 gap-x-3 gap-y-2 w-full">
      {showApplyButton && <AcceptQuoteButton />}
      {showRequestChangesButton && <RequestChangesButton />}
      <DeclineQuoteButton singleButton={!showRequestChangesButton} />
    </div>
  );
};

export default JobActionButtons;
